import { ContactDetails } from '@/components/contacts/details';
import { type InterviewType } from '@/types/interview';

export const InterviewContact = ({
  interview,
}: {
  interview: InterviewType;
}) => {
  return (
    <ContactDetails
      wrapperStyles={{ flex: 1 }}
      contact={interview?.candidate}
    />
  );
};
